<div class="list-page production-transfer-page">
  <div class="list-header">
    <div>
      <h3>Production Transfers</h3>
      <div class="muted">Reassign in-progress jobs from one employee to another.</div>
    </div>
    <div class="list-actions">
      <button mat-stroked-button color="primary" (click)="refresh()" [disabled]="loading">
        <mat-icon>refresh</mat-icon> Refresh
      </button>
      <button mat-flat-button color="primary" (click)="openCreate()" *ngIf="isAdmin">
        <mat-icon>add</mat-icon> Create Transfer
      </button>
    </div>
  </div>

  <div class="table-wrapper" *ngIf="isAdmin">
    <table mat-table [dataSource]="rows" class="mat-elevation-z1 transfer-table">
      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Transferred On</th>
        <td mat-cell *matCellDef="let r">{{ r.created_at | date:'dd MMM yyyy, hh:mm a' }}</td>
      </ng-container>
      <ng-container matColumnDef="job_no">
        <th mat-header-cell *matHeaderCellDef>Job</th>
        <td mat-cell *matCellDef="let r">
          {{ r.job?.job_no }}
          <div class="muted">{{ r.job?.patient_name }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="process">
        <th mat-header-cell *matHeaderCellDef>Process</th>
        <td mat-cell *matCellDef="let r">{{ r.process?.name }}</td>
      </ng-container>
      <ng-container matColumnDef="from_employee">
        <th mat-header-cell *matHeaderCellDef>From</th>
        <td mat-cell *matCellDef="let r">{{ r.from_employee?.name }}</td>
      </ng-container>
      <ng-container matColumnDef="to_employee">
        <th mat-header-cell *matHeaderCellDef>To</th>
        <td mat-cell *matCellDef="let r">{{ r.to_employee?.name }}</td>
      </ng-container>
      <ng-container matColumnDef="transfer_reason">
        <th mat-header-cell *matHeaderCellDef>Reason</th>
        <td mat-cell *matCellDef="let r" class="reason-cell">{{ r.transfer_reason }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div class="empty-state" *ngIf="!loading && rows.length === 0">
      No production transfers recorded yet.
    </div>

    <mat-paginator
      [length]="total"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[10, 25, 50]"
      (page)="onPage($event)"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
